import { TripStatusNotification } from './components/TripStatusNotification';
import type { NotificationMetaDataCallback } from './types';

export const FacilityTripRejectedRenderer = TripStatusNotification;

export const getMetaData: NotificationMetaDataCallback = (_notification) => {
  return {
    title: 'Trip Rejected (Facility Portal)',
  };
};
